// extracted by mini-css-extract-plugin
module.exports = {"card":"contact-support-main_card__Encin"};